var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFullscreen = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.0381 10.5478C3.62341 10.5478 4.04307 10.1171 4.04307 9.52071V8.68139L3.83324 5.18056L6.47267 7.95251L9.60906 11.111C9.7968 11.3098 10.0508 11.4092 10.3269 11.4092C10.9564 11.4092 11.4202 10.9895 11.4202 10.36C11.4202 10.0729 11.3098 9.80784 11.111 9.59801L7.96356 6.45058L5.18056 3.8222L8.70348 4.03203H9.55384C10.1502 4.03203 10.603 3.61237 10.603 3.01601C10.603 2.41966 10.1502 2 9.55384 2H3.75594C2.65157 2 2 2.64053 2 3.75594V9.52071C2 10.106 2.44174 10.5478 3.0381 10.5478ZM14.4241 22H20.222C21.3374 22 21.9779 21.3484 21.9779 20.2441V14.4793C21.9779 13.894 21.5472 13.4412 20.9509 13.4412C20.3655 13.4412 19.9348 13.8829 19.9348 14.4793V15.3076L20.1557 18.8194L17.5163 16.0364L14.3799 12.878C14.1811 12.6792 13.9382 12.5798 13.6621 12.5798C13.0326 12.5798 12.5687 12.9994 12.5687 13.6289C12.5687 13.9271 12.6792 14.1922 12.878 14.3909L16.0254 17.5384L18.8084 20.1668L15.2855 19.9569H14.4241C13.8388 19.9569 13.386 20.3766 13.386 20.9729C13.386 21.5693 13.8277 22 14.4241 22Z",
    fill: "#878793"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 1.28483,
    y: 2,
    width: 21.4083,
    height: 21.4303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.715173
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.357586
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFullscreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-fullscreen.3c6f4bf52f279a5251ebc82257f0e1be.svg";